import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@elaniintc/goes-design-system";
import { useCorrectionForm } from "../context";

interface FormCorrectionRejectModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onReject: () => void;
  isLoading: boolean;
}

export const FormCorrectionRejectModal = ({
  isOpen,
  onOpenChange,
  onReject,
  isLoading,
}: FormCorrectionRejectModalProps) => {
  const {
    rejectComments,
    setRejectComments,
    groupCorrectionInCurrentCycle: correction,
  } = useCorrectionForm();
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-156 gap-6">
        <DialogHeader className="space-y-3">
          <DialogTitle className="text-3xl font-semibold text-heading text-center">
            Rechazar comentarios
          </DialogTitle>
          <DialogDescription className="text-base text-body leading-6 text-center">
            ¿Estás seguro de que deseas rechazar la revisión por{" "}
            <span className="text-action-loud font-semibold">
              {(() => {
                // Creator puede estar en comments[0].creator o field_corrections[0].comments[0].creator
                const creatorFromComments = correction?.comments?.[0]?.creator;
                const creator = creatorFromComments || correction?.creator;

                const fullName =
                  creator && typeof creator === "object" && "name" in creator
                    ? `${creator?.name || ""} ${creator?.last_name || ""}`?.trim()
                    : "nombre de técnico";

                return fullName;
              })()}
            </span>{" "}
            ? La revisión en esta vuelta de revisión será eliminada y marcada
            como revisión pendiente.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <label
            htmlFor="reject"
            className="text-sm font-semibold text-heading block"
          >
            Motivo del rechazo<span className="text-danger-loud">*</span>
          </label>
          <Textarea
            id="reject"
            value={rejectComments}
            onChange={(e) => setRejectComments(e.target.value)}
            placeholder="Escribe el motivo del rechazo..."
            rows={4}
            className="w-full resize-none"
          />
        </div>
        <DialogFooter className="flex flex-row gap-3 sm:flex-row">
          <Button
            variant="quiet"
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
            className="flex-1"
          >
            Cancelar
          </Button>
          <Button
            variant="danger-primary"
            onClick={onReject}
            disabled={!rejectComments.trim() || isLoading}
            className="flex-1"
          >
            {isLoading ? "Rechazando..." : "Rechazar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
